import type { FloraCanvasModelProps } from '@/components/home/components/flora-canvas/flora-canvas.model'
import { useFloraCanvasModel } from '@/components/home/components/flora-canvas/flora-canvas.model'
import { FloraCanvasView } from '@/components/home/components/flora-canvas/flora-canvas.view'

export function FloraCanvasViewModel(props: FloraCanvasModelProps) {
  const model = useFloraCanvasModel(props)
  return <FloraCanvasView {...model} />
}
